gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

const BODY = $("body");

const mainAnimJS = {
  toggleClassAnim: function () {
    setTimeout(() => {
      const animEl = document.querySelectorAll(".anim");
      const anims = gsap.utils.toArray(animEl);
      anims.forEach((el, i) => {
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            start: "0 70%",
            scrub: true,
            onEnter: (el) => {
              anims[i].classList.add("show");
            },
            onLeaveBack: () => {
              anims[i].classList.remove("show");
            }
          }
        })
      })
    }, 500)
  },

  intro: () => {
    const introWrap = $(".intro_wrap");
    $("body").addClass("scrollLock");
    setTimeout(() => {
      BODY.addClass("scrollLock");
      $(".intro_wrap h2").addClass("hide");
      introWrap.addClass("hide");
    }, 500);
    setTimeout(() => {
      BODY.removeClass("scrollLock");
    }, 3000);
    setTimeout(() => {
      $(".main .sec_visual .txt").addClass("show");
    }, 1000)
  },

  mainSlide: function () {
    gsap.set(".sec_slide h2", {
      x: $(window).innerWidth(),
    })
    gsap.to(".sec_slide h2", {
      xPercent: -100,
      ease: "none",
      scrollTrigger: {
        trigger: ".sec_slide",
        pin: ".sec_slide h2",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      }
    })
  },

  autoTxtPin: function () {
    gsap.to(".sec_student ", {
      scrollTrigger: {
        trigger: ".txt_auto_slide",
        pin: true,
        pinSpacing: true,
        scrub: true,
        start: 'top top',
        end: "+=100%"
      }
    })
  },

  init: function () {
    $(".intro_wrap").length !== 0 ? this.intro() : undefined;
    $(".sec_slide").length !== 0 ? this.mainSlide() : undefined;
    this.toggleClassAnim();
    $(".txt_auto_slide").length !== 0 ? this.autoTxtPin() : undefined;
  }
}


document.addEventListener("DOMContentLoaded", ready);

function ready() {
  mainAnimJS.init();
}